export const enum CharacterStatus {
  NONE,
  INCORRECT,
  MISPLACED,
  CORRECT,
}

export const enum GameStatus {
  PLAYING,
  WIN,
  LOSE,
}

export const enum ButtonStatus {
  NONE,
  INCORRECT,
  MISSPLACED,
  CORRECT,
}
